import { Link } from "react-router-dom";
import { SOCIALS } from "../lib/data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#0B0B0B] mt-32"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif-display text-4xl md:text-5xl text-white leading-[1.05]">
            Shaji <span className="text-[var(--accent)]">Nada</span>
          </h3>
          <p className="mt-5 text-white/60 font-light max-w-md leading-relaxed">
            Producer, founder, and storyteller championing South Asian voices on the global stage. Based in Toronto.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5">Explore</p>
          <ul className="space-y-3 text-white/70">
            {[
              ["About", "/about"],
              ["Ventures", "/ventures"],
              ["Films", "/films"],
              ["Press", "/press"],
              ["Journal", "/journal"],
              ["Contact", "/contact"],
            ].map(([label, href]) => (
              <li key={href}>
                <Link
                  to={href}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="link-underline hover:text-white"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-5">Connect</p>
          <ul className="space-y-3 text-white/70">
            {SOCIALS.map((s) => (
              <li key={s.name}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="link-underline hover:text-white"
                >
                  {s.name}
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-8 text-white/40 text-sm">
            Email: <a href="mailto:Shaji@idealgroup.ca" data-testid="footer-email" className="text-white/70 hover:text-[var(--accent)]">Shaji@idealgroup.ca</a>
          </p>
          <p className="text-white/40 text-sm">
            Phone: <a href="tel:+14163566500" data-testid="footer-phone" className="text-white/70 hover:text-[var(--accent)]">+1 (416) 356-6500</a>
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-white/40 text-xs uppercase tracking-[0.2em]">
          <span>© {new Date().getFullYear()} Shaji Nada</span>
          <span>Toronto · Chennai · Worldwide</span>
        </div>
      </div>
    </footer>
  );
}
